export const SEARCH_TYPE_COOKIE = 'search_type_cookie';
export const SEARCH_VIEW_COOKIE = 'search_view_cookie';
export const SEARCH_FILTER_COOKIE = 'search_filter_cookie';
export const BOOK_LIVE_DEMO_URL = 'https://info.vulners.com/meetings/andrey-lukashenkov';
export const MOBILE_BREAK_POINT = 600;
